import {
  Caption_default
} from "./chunk-53QECED6.mjs";
import {
  Heading_default
} from "./chunk-55O4GHJX.mjs";
import {
  Body_default
} from "./chunk-VSI5NSFV.mjs";

// src/Typography.tsx
import { memo } from "react";
import { forwardRef } from "@julo-ui/system";
import { jsx } from "react/jsx-runtime";
var Typography = forwardRef(
  (props, ref) => {
    const { type } = props;
    switch (type) {
      case "heading":
        return /* @__PURE__ */ jsx(Heading_default, { ref, ...props });
      case "caption":
        return /* @__PURE__ */ jsx(Caption_default, { ref, ...props });
      default:
        return /* @__PURE__ */ jsx(Body_default, { ref, ...props });
    }
  }
);
Typography.displayName = "Typography";
var Typography_default = memo(Typography);

export {
  Typography_default
};
